export const deltaRowStyles = {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
};
